export default __webpack_public_path__ + "weebly.59af3775.png";